import {
  List,
  Paper,
  Divider,
  ListItemButton,
  Skeleton,
  Typography,
} from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { useItems } from '@scorenco/components';
import { RouteLink, Types, useTranslation } from '@scorenco/core';

type CompetitionListProps = BoxProps & {
  area: string;
  leagues?: Types.Competitions_League_Detail[];
};

export const CompetitionList = ({
  area,
  leagues,
  ...rest
}: CompetitionListProps) => {
  const { t } = useTranslation();
  const items = useItems(leagues, 5);

  return (
    <Box key={area} {...rest}>
      <Typography
        variant="h5"
        sx={{ textTransform: 'uppercase', fontStyle: 'unset', mb: 2 }}
      >
        {area !== 'unknown' ? (
          t(`COMPETITION_AREA_${area}`)
        ) : (
          <Skeleton width={200} />
        )}
      </Typography>

      <Paper variant="bordered" sx={{ padding: 0, alignItems: 'stretch' }}>
        <List disablePadding>
          {items.map((league, idx) => (
            <>
              {idx !== 0 && <Divider key={`divider-${league?.id}`} />}
              <ListItemButton
                key={`link-${league?.id}`}
                component={RouteLink}
                href={league?.url}
              >
                {league?.name || <Skeleton width={200} />}
              </ListItemButton>
            </>
          ))}
        </List>
      </Paper>
    </Box>
  );
};
